import { Skeleton } from "@monorepo-apps/ui/src/components/skeleton";

import { BOARD_COLUMNS, BOARD_MIN_WIDTH, buildGridTemplate } from "@/presentation/data/board";

const GRID = buildGridTemplate(BOARD_COLUMNS);
const COL_COUNT = BOARD_COLUMNS.length;

/**
 * Loading placeholder that mirrors the board's group → table layout, so the
 * page keeps its shape while data arrives (instead of a bare "Loading…" line).
 */
export function BoardSkeleton({ groups = 3, rowsPer = 4 }: { groups?: number; rowsPer?: number }) {
  return (
    <div className="flex flex-col gap-4" aria-hidden>
      {Array.from({ length: groups }).map((_, gi) => (
        <section key={gi} className="glow-card-static overflow-hidden rounded-xl">
          {/* group header */}
          <div
            className="flex items-center gap-3 px-4 py-3"
            style={{ boxShadow: "inset 3px 0 0 var(--border)" }}
          >
            <Skeleton className="size-4 rounded" />
            <div className="flex flex-1 flex-col gap-1.5">
              <Skeleton className="h-2.5 w-16" />
              <Skeleton className="h-3.5 w-48" />
            </div>
            <Skeleton className="h-1.5 w-24 rounded-full" />
            <Skeleton className="h-3 w-10" />
          </div>

          {/* table header + rows on the real grid template */}
          <div className="border-border border-t">
            <div className="overflow-hidden">
              <div style={{ minWidth: BOARD_MIN_WIDTH }}>
                <div
                  className="border-border bg-muted/30 grid w-full items-center border-b"
                  style={{ gridTemplateColumns: GRID }}
                >
                  <div className="px-3 py-2.5">
                    <Skeleton className="h-2.5 w-10" />
                  </div>
                  {Array.from({ length: COL_COUNT }).map((_, ci) => (
                    <div key={ci} className="border-border/60 border-l px-3 py-2.5">
                      <Skeleton className="h-2.5 w-12" />
                    </div>
                  ))}
                </div>

                {Array.from({ length: rowsPer }).map((_, ri) => (
                  <div
                    key={ri}
                    className="border-border grid w-full items-center border-t"
                    style={{ gridTemplateColumns: GRID }}
                  >
                    {/* sticky Item column */}
                    <div className="flex items-center gap-2 py-2.5 pr-2 pl-2">
                      <Skeleton className="size-4 rounded" />
                      <div className="flex flex-1 flex-col gap-1">
                        <Skeleton className="h-3 w-[70%]" />
                        <Skeleton className="h-2 w-[40%]" />
                      </div>
                    </div>
                    {Array.from({ length: COL_COUNT }).map((_, ci) => (
                      <div
                        key={ci}
                        className="border-border/60 flex items-center border-l px-3 py-2.5"
                      >
                        <Skeleton className="h-3.5 w-[70%]" />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
